<template>
  <el-main>
    <div class="control-bar">
      <div class="title">{{ currentTitle }}</div>
      <el-form>
        <el-form-item>
          <el-select v-model="id" @change="getDetail">
            <el-option v-for="item in cates" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-form>
      <el-form-item>
        <WangToolbar :editor="editor" :defaultConfig="toolbarConfig" />
        <WangEditor :defaultConfig="editorConfig" @onCreated="onCreated" mode="default" style="height: 600px" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveSetting" class="save-button">保存</el-button>
      </el-form-item>
    </el-form>
  </el-main>
</template>

<script>
import {
  httpRequest
} from "@/utils/app";

export default {
  data () {
    return {
      editor: null,
      editorConfig: {},
      toolbarConfig: {},
      showSource: false,
      uploadUrl: "",
      id: "",
      cates: [],
    };
  },
  computed: {
    // 当前选中分类的标题
    currentTitle () {
      const item = this.cates.find(c => c.id === this.id);
      return item ? item.title : "";
    },
  },
  created () {
    // 编辑器/工具栏配置必须在子组件 Editor 创建（早于父组件 mounted）前就绪，故放在 created
    this.uploadUrl = httpRequest({
      action: "upload_thumb",
      width: 800,
    },
      "GET",
      true
    );

    this.editorConfig = {
      placeholder: "请输入内容...",
      MENU_CONF: {
        uploadImage: {
          server: this.uploadUrl,
          fieldName: "file",
          maxFileSize: 10 * 1024 * 1024,
          allowedFileTypes: [
            "image/jpg",
            "image/jpeg",
            "image/png",
            "image/gif",
          ],
        },
        uploadVideo: {
          server: this.uploadUrl,
          fieldName: "file",
          allowedFileTypes: ["video/mp4"],
          maxFileSize: 1024 * 1024 * 10,
        },
        uploadAttachment: {
          server: this.uploadUrl,
          fieldName: "file",
          allowedFileTypes: [],
        },
      },
    };

    this.toolbarConfig = {
      toolbarKeys: [
        "fontSize",
        "bold",
        "underline",
        "italic",
        "through",
        "color",
        "sub",
        "sup",
        {
          key: "group-indent",
          title: "缩进",
          iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
          menuKeys: ["indent", "delIndent"],
        },
        {
          key: "group-justify",
          title: "对齐",
          iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',
          menuKeys: [
            "justifyLeft",
            "justifyRight",
            "justifyCenter",
            "justifyJustify",
          ],
        },
        "bulletedList",
        "numberedList",
        "|",
        "insertLink",
        "insertTable",
        "uploadImage",
        "uploadVideo",
        "uploadAttachment",
        "|",
        "clearStyle",
        "redo",
        "undo",
        "fullScreen",
        "html",
      ],
    };
  },
  mounted () {
    // 监听源码切换事件
    window.addEventListener('wangeditor-toggle-source', this.toggleSource);

    // 加载自定义页面分类，并默认选中第一条
    this.getCates();
  },
  methods: {
    // 获取自定义页面分类（后端按 ord 升序返回），默认选中第一条
    getCates () {
      httpRequest({
        action: "pageset_cates",
      }).then((response) => {
        if (response.error === false && response.data) {
          // 后端返回 { id: { id, title, ord } } 结构，转为数组并按 ord 升序
          const list = Object.keys(response.data).map(key => response.data[key]);
          list.sort((a, b) => Number(a.ord) - Number(b.ord));
          this.cates = list;
          // 默认选中第一条并加载其内容
          if (list.length > 0) {
            this.id = list[0].id;
            this.getDetail();
          }
        }
      });
    },
    onCreated (editor) {
      this.editor = Object.seal(editor);
    },
    toggleSource () {
      if (!this.editor) return;

      if (this.showSource) {
        // 从源码模式切换回编辑模式
        // 获取编辑器当前的纯文本内容作为HTML源码
        const sourceText = this.editor.getText();
        this.editor.setHtml(sourceText);
        this.showSource = false;
      } else {
        // 从编辑模式切换到源码模式
        // 获取HTML源码并以纯文本形式显示在编辑器中
        const htmlContent = this.editor.getHtml();
        this.editor.clear();
        this.editor.insertText(htmlContent);
        this.showSource = true;
      }

      // 设置全局状态，用于按钮激活状态同步
      window.__wangeditor_source_mode__ = this.showSource;
    },
    getDetail () {
      httpRequest({
        action: "pageset_detail",
        id: this.id,
      }).then((response) => {
        if (response.error === false) {
          if (this.editor) {
            this.editor.setHtml(response.data.content);
          }
        }
      });
    },
    saveSetting () {
      let content;
      if (this.showSource) {
        // 如果当前是源码模式，获取编辑器中的纯文本作为HTML源码
        content = this.editor.getText();
      } else {
        // 如果是编辑模式，直接获取HTML内容
        content = this.editor.getHtml();
      }

      httpRequest({
        action: "pageset_add",
        id: this.id,
        content: content
      },
        "post"
      ).then((response) => {
        if (response.error === false) {
          this.$message({
            type: "success",
            message: response.msg,
          });
        } else {
          this.$message({
            type: "error",
            message: response.msg,
          });
        }
      });
    },
  },
  beforeDestroy () {
    window.removeEventListener('wangeditor-toggle-source', this.toggleSource);
    // 销毁编辑器实例，释放内存
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
};
</script>

<style scoped>
/* 保存按钮基础样式 */
.save-button {
  position: relative;
  z-index: 9999;
}
</style>

<style>
/* 全局样式：王编辑器全屏模式下保存按钮及表单容器的位置覆盖 */
/* 检测全屏模式的多种可能类名 */
.w-e-full-screen-container .save-button,
.w-e-fullscreen-container .save-button,
.wang-editor-fullscreen .save-button,
body.w-e-full-screen .save-button {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 10000 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

/* 全屏模式下保存按钮的父容器 */
.w-e-full-screen-container .el-form-item,
.w-e-fullscreen-container .el-form-item,
.wang-editor-fullscreen .el-form-item,
body.w-e-full-screen .el-form-item {
  position: fixed !important;
  bottom: 0 !important;
  right: 0 !important;
  margin: 0 !important;
  z-index: 10000 !important;
  background: transparent !important;
}

/* 通用全屏检测 - 当body或html有全屏相关类时 */
body[class*="full"] .save-button,
html[class*="full"] .save-button {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 10000 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}
</style>
